import calendarRowUserComponentUrl from './calendarRowUserComponent.html';
class CalendarRowUserCtrl {
  constructor(Authentication, LaborUISchema) {
    'ngInject';

    Object.assign(this, { Authentication, LaborUISchema });
  }

  $onInit() {
    this.laborCostSubscriptionLevel =
      this.Authentication.user.orgSettings.premiumFeatures.laborCost;
  }

  isRed() {
    if (!this.Authentication.user.hasAccessToLaborCost) {
      return false;
    }

    return this.LaborUISchema.evalColor(this.laborSchema, this.consolidateTotals(this.user), {
      showLaborCost: this.showLaborCost,
      showCountOfHours: this.showCountOfHours,
    }).red;
  }

  consolidateTotals(userObject) {
    return ['totals', 'foreignTotals'].reduce((agg, totals) => {
      if (!agg) {
        return { ...userObject[totals] };
      }

      Object.keys(agg).forEach((prop) => (agg[prop] += userObject[totals][prop] || 0));
      return agg;
    }, null);
  }

  canSeeTotals(user) {
    return (
      user.isMe ||
      this.Authentication.user.isManager ||
      this.Authentication.user.orgSettings.usersSeeHoursOfOthers
    );
  }

  get laborSchema() {
    return this.LaborUISchema.schema?.calendarUISchema?.userRow;
  }

  filterLaborRow = (item) => this.LaborUISchema.evalIf(item, this);
}

export default {
  bindings: {
    user: '<',
    showLaborCost: '<',
    showCountOfHours: '<',
    showAllTotals: '<',
  },
  controllerAs: 'ctrl',
  controller: CalendarRowUserCtrl,
  templateUrl: calendarRowUserComponentUrl,
};
